import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const BrushIcon = (props)=>{
    const { size = 16, intent = 'success', testId } = props, rest = _object_without_properties(props, [
        "size",
        "intent",
        "testId"
    ]);
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), {
        "data-testid": testId || "brush-icon-".concat(intent),
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19.9171 5.27116C18.7428 8.19925 15.7994 12.1796 13.3364 14.1545L11.8341 15.3593C11.6435 15.4966 11.4529 15.6186 11.2394 15.7025C11.2394 15.5652 11.2317 15.4127 11.2089 15.2678C11.125 14.6273 10.8352 14.0325 10.3243 13.5217C9.80579 13.0031 9.17288 12.6981 8.52472 12.6142C8.37222 12.6066 8.21971 12.5914 8.0672 12.6066C8.15108 12.3702 8.28071 12.1491 8.44084 11.9661L9.63041 10.4639C11.5978 8.00099 15.5935 5.0424 18.514 3.87575C18.9639 3.70799 19.3986 3.83 19.6731 4.11213C19.9628 4.39426 20.1001 4.8289 19.9171 5.27116Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.2398 15.7025C11.2398 16.5412 10.9195 17.3419 10.3171 17.9519C9.85194 18.417 9.21903 18.7373 8.46412 18.8364L6.58827 19.0423C5.56646 19.1567 4.68954 18.2874 4.81155 17.2504L5.01744 15.3746C5.20045 13.7046 6.59589 12.6371 8.07522 12.6066C8.22773 12.599 8.38787 12.6066 8.53275 12.6142C9.18091 12.6981 9.81382 12.9955 10.3323 13.5216C10.8432 14.0325 11.133 14.6273 11.2169 15.2678C11.2245 15.4127 11.2398 15.5576 11.2398 15.7025Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.1449 13.3005C14.1449 11.3104 12.5283 9.69382 10.5381 9.69382",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            })
        ]
    }));
};
